(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifFilter', swifFilter)
    .directive('swifOpenFilterInModal', swifOpenFilterInModal)
    .filter('selectSearchFilter', selectSearchFilter)
    .controller('FilterAddCtrl', FilterAddCtrl);


    function FilterAddCtrl($scope, $location, dataService) {
        var $ctrl = this;
        // dirty fix because contracts in patrimoine and parcauto have the same content type... :'(
        if ($scope.model.model_id==='project.project') {
            if ($location.path()==='/parcauto/contracts/table_view'){
                $scope.model.domain.push(['service_id.is_parcauto', '=', 'true'])
            }
        }
    }

    /**
     * Handles filtering for both API searches and local choices searches
     * In the case of API search, it simply returns the items because the backend
     * already filterd the results.
     * In the case of local choices, it returns the results of the default
     * angular filter
     **/
    function selectSearchFilter ($filter) {
        return function (items, search, settings, filterTarget) {
            var filterSettings = _.find(settings, {'field': filterTarget.field});

            if (filterSettings && filterSettings.choices) {
                return items;
            } else {
                return $filter('filter')(items, search);
            }
        }
    }

    /**
    * @ngdoc directive
    * @name swifFilter
    * @module swif.ui
    * @restrict EA
    * @description
    * the job of the following directive:
    * * display a search toolbar
    * * being contentType specific but powerfull
    * * handle the 'or' and 'and' operators
    * @usage
    * <swif-filter ng-model="macollection"></swif-filter>
    **/
    function swifFilter(swif, swifAvailableService, gettextCatalog, swifOpenbaseCompanyService){
        'ngInject';

        var directive = {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                totalCount: '&?',
                dropdownSide: '@?' // default : right
            },
            templateUrl: 'partials/ui/filter.html'
        };
        directive.link = link;
        return directive;

        function link(scope, element, attr, ngModel) {
            scope.dropdownSide = scope.dropdownSide || 'right';
            scope.text = {value: ''};
            scope.displayFilterForm = false;
            scope.displayFilters = false;
            scope.operators = {};
            scope.operator = 'and'; //should be analyse from the currentquery
            scope.vocabulary = {};
            scope.vocabularyDisplay = {};
            scope.widgets = {};
            scope.textFields = [];
            scope.limitPerPage = {};
            scope.loading = {};
            scope.sortOrders = [
                {
                    id: 'ASC',
                    name: 'Ascendant',
                    icon: 'sort-asc'
                },
                {
                    id: 'DESC',
                    name: 'Descendant',
                    icon: 'sort-desc'
                }
            ];
            scope.fullView = _.contains(swif.user.getAuthenticatedUserData().access_rights, 'openstc_full_view');

            scope.setSortOrder = function (order) {
                scope.sortOrder = order;
            };
            var loadOperator = function () {
                scope.operator = 'and';
                if (!_.isEmpty(scope.filters)) {
                    var countPipe = scope.filters.filter(function (filter) {
                        return filter === '|';
                    }).length;
                    if (countPipe === scope.filters.length - 1 && scope.filters.length > 1) {
                        scope.operator = 'or';
                    } else {
                        scope.operator = 'and';
                    }
                }
            };

            var addTextFilters = function () {
                var value = scope.text.value;
                if (!value) {
                    return;
                }

                if (scope.contentType.simpleSearchTextFields) {
                    // Add fields if available condition is true
                    if (swifAvailableService.isAvailable(scope.contentType.simpleSearchTextFields)) {
                        scope.textFields = [...scope.textFields, ...scope.contentType.simpleSearchTextFields.fields];
                    }
                }

                var valueNumber = parseInt(value, 10);
                var isNumber = !isNaN(valueNumber);

                var textFields = scope.textFields.length;

                if (isNumber) {
                    if (textFields > 0) {
                        swif.data.addExtraFilter(scope.collection.currentFilter, 'text', '|');
                    }
                    swif.data.addExtraFilter(scope.collection.currentFilter, 'text', 'id', '=', valueNumber);
                }

                if (textFields > 1) {
                    for (var i = 0; i < textFields - 1; i++) {
                        swif.data.addExtraFilter(
                            scope.collection.currentFilter, 'text', '|'
                        );
                    }
                }
                _.forEach(scope.textFields, function (field) {
                    var operator = 'ilike';
                    if (value) {
                        swif.data.addExtraFilter(
                            scope.collection.currentFilter, 'text',
                            field, operator, value
                        );
                    }
                });
            };

            var loadTextFilters = function () {
                scope.textFields = [];
                var filters = swif.data.getExtraFilters(scope.collection.currentFilter);
                if (filters) {
                    _.forEach(filters.text, function (filter) {
                        if (_.isString(filter.value)) {
                            scope.text.value = filter.value;
                        }
                    });
                }
                swif.data.getModelFields(scope.collection.contentType)
                .then(function (modelFields) {
                    _.forOwn(modelFields, function (field, fieldId) {
                        if ((field.type === 'char' || field.type === 'text')) {
                            // selectable is enough, NOTHING ELSE ! That's exactly its reason to be
                            if (field.selectable) {
                                scope.textFields.push(fieldId);
                            }
                        }
                    });
                });
            };
            var onError = function (error) {
                swif.message.addError(error);
            };

            var loadVocabularies = function () {
                var params;
                var typeToField = {};
                params = {};
                _.forEach(scope.settings, function (filter) {
                    if (_.isArray(filter.vocabulary)) {
                        scope.vocabulary[filter.field] = filter.vocabulary;
                    }
                    if (filter.type === 'list' || filter.type === 'tree') {
                        if (!_.isArray(filter.vocabulary) && filter.vocabulary !== undefined) {
                            _.forOwn(filter.vocabulary, function (value, key) {
                                params[key] = value;
                                typeToField[key] = filter.field;
                                scope.vocabulary[filter.field] = [];
                                scope.widgets[filter.field] = 'multiselect';
                            });
                        } else if (_.isArray(filter.vocabulary)) {
                            scope.widgets[filter.field] = 'multiselect';
                        } else if (filter.choices !== undefined) {
                            scope.vocabulary[filter.field] = [];
                            scope.widgets[filter.field] = 'multiselect';
                        }
                        if (filter.type === 'list') {
                            scope.operators[filter.field] = swif.filter.operators.multiselect;
                        } else {
                            scope.operators[filter.field] = swif.filter.operators.tree;
                        }

                        // Store a display copy of the vocabulary
                        scope.vocabularyDisplay[filter.field] = scope.vocabulary[filter.field];
                    } else if (filter.type === 'date') {
                        scope.widgets[filter.field] = 'date';
                        scope.operators[filter.field] = swif.filter.operators.date;
                        scope.vocabulary[filter.field] = swif.filter.vocabularies.date;
                    } else if (filter.type === 'number') {
                        scope.widgets[filter.field] = 'number';
                        scope.operators[filter.field] = swif.filter.operators.number;
                    } else if (filter.type === 'bool') {
                        scope.widgets[filter.field] = 'bool';
                        scope.operators[filter.field] = swif.filter.operators.bool;
                    } else if (filter.type === 'text') {
                        scope.widgets[filter.field] = 'text';
                        scope.operators[filter.field] = swif.filter.operators.text;
                    } else if (filter.type === 'isSetOrNotSet') {
                        scope.widgets[filter.field] = 'isSetOrNotSet';
                        scope.operators[filter.field] = swif.filter.operators.isSetOrNot;
                    }
                });
                scope.sortOnFields = [];
                if (scope.contentType.sortOn) {
                    _.forEach(scope.contentType.sortOn, function (field) {
                        scope.sortOnFields.push({
                            id: field.id,
                            name: field.name,
                            relation: field.relation
                        });
                    });
                } else {
                    scope.sortOnFields.push({
                        id: 'id',
                        name: 'Id'
                    });
                    scope.sortOnFields.push({
                        id: 'name',
                        name: 'Name'
                    });
                }
                scope.filters.forEach(loadFilterData);
            };

            var loadFilterData = function (filter) {
                var settings = getFilterSettings(filter);
                var params = {};

                if (!settings) {
                    return;
                }
                if (!settings.choices) {
                    return;
                } else {
                    params = angular.copy(settings.choices);
                    params.fields = ['id', 'name', 'complete_name'];
                }
                if (scope.widgets[filter.field] === 'multiselect' && scope.vocabulary[filter.field].length === 0) {
                        // Load the *multiselected* filters (sites, equipments, etc...) to *show* them to the user
                        var value = angular.copy(filter.value);
                        if (value && _.isNumber(value)) {
                            value = [value];
                        // We must handle others values like boolean to avoid to do huge requests (like getting 200K sites)
                        // in case of 'set' or 'not set' filters
                        } else if(!_.isArray(value)) {
                            value = [];
                        }

                        swif.data.addFilter(params, 'id', 'in', value);

                        swif.data.get(settings.content_type, undefined, params)
                            .then(function (values) {
                                scope.vocabulary[filter.field] = values;
                            });
                }
            };

            var loadMyFilters = function () {
                swif.filter.loadMyFilters(
                    scope.contentType.model
                )
                .then(function (data) {
                    var res = [];
                    var contentType = scope.collection.contentType;
                    _.forEach(data, function (item) {
                        var uiContentType = item.ui_context ? item.ui_context.contentType : null;
                        var onylExplicit = scope.contentType.onlyExplicitFilters;
                        if (!onylExplicit && !uiContentType || uiContentType && uiContentType === contentType) {
                            res.push(item);
                        }
                    });
                    scope.myFilters = res;
                });
            };

            // For 'is_set' and 'is_not_set' filters, reset good operators
            var formatIsSetFilters = function(filters) {
                if (scope.filters.length) {
                    _.forEach(scope.filters, function(filter) {
                        if (filter.operator == '=' && filter.value === false) {
                            filter.operator = 'is_not_set';
                        } else if (filter.operator == '!=' && filter.value === false) {
                            filter.operator = 'is_set';
                        }
                    })
                }
            }

            /*
              @TOCHECK: for now, we send the 'domain' value as an Array, instead of String.
                As the server evaluates 'domain' as an Array, and ONLY THEN, saving it using toString (field Char behavior),
                that's why, according to the server programming language (python for example), some keyword (like true or false)
                may not have the same format as the JS synthax (and so may be different from the original value sent to server).
                Should we force the domain as String ?
                  - If yes, the server may not be able to use the filter byt itself (in its own language)
                  - if no, we should maintain the maps between JS synthax and server language synthax
            */
            scope.setCurrentCustomFilter = function (customFilter) {
                var filter = {};
                filter.domain = customFilter.domain;
                if (customFilter.limit) {
                    filter.limit = scope.limitPerPage.limit = customFilter.limit;
                }
                if (customFilter.sort) {
                    filter.sort = customFilter.sort;
                }
                swif.filter.setCollectionFilter(scope.collection, filter);
                let filters = swif.data.getFilters(scope.collection.currentFilter);
                loadFilterData(filters[0]);
                setSortOn();
            };
            var addCustomFilterAction = swif.action.getActionById('filter', 'list', 'add');

            scope.parseUiContext = function () {
                return {contentType: scope.collection.contentType};
            };

            scope.addCustomFilter = function () {
                if (scope.filters.findIndex(o => o.value === undefined) !== -1) {
                    swif.message.addNotice(gettextCatalog.getString('Please fill all required fields.'));
                    return;
                }
                //dispatch the add action ?
                var rawFilter;
                scope.updateModel();
                rawFilter = angular.copy(scope.collection.currentFilter);

                var userData = swif.user.getAuthenticatedUserData();
                // to support alert you must have a table view
                var hasTableView = !!swif.action.getActionById(scope.contentType.id, 'views', 'table');
                var model = {
                    _type: 'filter',
                    _hasTableView: hasTableView,
                    model_id: scope.contentType.model,
                    domain: rawFilter.domain,
                    user_id: [userData.id, userData.complete_name],
                    pre_recorded: false,
                    ui_context: scope.parseUiContext(),
                    limit: scope.limitPerPage.limit
                };
                if (scope.sortOn && scope.sortOn.value) {
                  model.sort = scope.sortOn.value.id + ' ' + scope.sortOrder.id
                }
                swif.action.dispatch(
                    'filter',
                    addCustomFilterAction,
                    model,
                    {callback: scope.callbackFilter}
                );
            };
            scope.callbackFilter = function (error, data) {
                swif.filter.callback(error, data);
                loadMyFilters();
                if (!error && data.model.is_alert) {
                    swif.alerter.loadAlertFilters();
                }
            };

            scope.toggleFilterForm = function (){
                scope.displayFilterForm = !scope.displayFilterForm;
                scope.displayFilters = false;
            };
            scope.toggleFilters = function (){
                scope.displayFilters = !scope.displayFilters;
                scope.displayFilterForm = false;
            };
            var getFilterSettings = function (filter) {
                if (_.isUndefined(scope.settings)) {
                    return [];
                }
                for (var i = 0; i < scope.settings.length; i++) {
                    if (scope.settings[i].field === filter.field) {
                        return scope.settings[i];
                    }
                }
            };
            scope.getFilterName = function (filter) {
                var settings = getFilterSettings(filter);
                if (settings !== undefined) {
                    return settings.name;
                }
            };
            scope.getFilterOperator = function (filter) {
                var operators = scope.operators[filter.field];
                if (operators !== undefined) {
                    for (var i = 0; i < operators.length; i++) {
                        if (filter.operator === operators[i].value) {
                            return operators[i];
                        }
                    }
                }
            };
            scope.setFilterOperator = function (filter, operator) {
                filter.operator = operator.value;
            };
            scope.removeFilter = function(filter) {
                var index = scope.filters.indexOf(filter);
                if(index > -1) {
                    scope.filters.splice(index, 1);
                }
            };
            scope.resetFilters = function () {
                scope.filters = [];
                scope.limitPerPage.limit = 20;
                scope.sortOn = {order: scope.sortOrders[0].id, value: scope.sortOnFields[0]};
                scope.updateModel();
                //delete scope.text.value;
            };
            scope.downloadCSV = function ($event) {
                swif.collection.saveAs(scope.collection);
            };

            scope.updateModel = function () {
                scope.displayFilterForm = false;
                swif.data.resetFilterDomain(scope.collection.currentFilter);
                var count = scope.filters.length;

                swif.data.resetExtraFilter(scope.collection.currentFilter, 'text');
                if (!_.isEmpty(scope.text.value)) {
                    addTextFilters();
                }
                if (scope.operator === 'or' && count > 1) {
                    for (var i = 0; i < count - 1; i++) {
                        scope.filters.splice(0, 0, '|');
                    }
                }
                _.forEach(scope.filters, function (filter) {
                    if (filter === '|') {
                        swif.data.addFilter(scope.collection.currentFilter, '|');
                    } else {
                        var operator = filter.operator;
                        var value = filter.value;
                        if(filter.operator === 'is_set' || filter.operator === 'is_not_set') {
                            operator = filter.operator === 'is_set' ? '!=' : '=';
                            value = false;
                        }
                        if (value !== undefined) {
                            swif.data.addFilter(
                                scope.collection.currentFilter,
                                filter.field,
                                operator,
                                value
                            );
                        }
                    }
                });
                if (scope.operator === 'or') {
                    scope.filters.splice(0, count - 1);
                }
                if (scope.collection.currentFilter.limit !== scope.limitPerPage.limit) {
                    swif.data.setLimit(scope.collection.currentFilter, scope.limitPerPage.limit);
                }
                if (scope.sortOn) {
                    if (scope.sortOn.value && scope.collection.currentFilter) {
                        swif.data.sortOn(
                            scope.collection.currentFilter,
                            scope.sortOn.value.id,
                            scope.sortOrder.id
                        );
                    }
                }
            };
            scope.setCurrentStateFilter = function (state, field) {
                scope.displayFilters = false;
                var filters = swif.data.getFilters(scope.collection.currentFilter);
                var found = false;
                _.forEach(filters, function (filter) {
                    if (filter.field === field) {
                        filter.value = [state.id];
                        filter.operator = 'in';
                        found = true;
                    }
                });
                if (!found) {
                    swif.data.addFilter(scope.collection.currentFilter, field, 'in', [state.id]);
                } else {
                    swif.data.setFilters(scope.collection.currentFilter, filters);
                }
            };
            scope.getStateByValue = function (state, type) {
                var contentTypes = {
                    state : 'states',
                    first_response_time_status : 'first_response_time_states',
                    response_time_status : 'response_time_states',
                    total_process_time_status : 'total_process_time_states'
                };
                var currentContentType = contentTypes[type];
                var ob;
                _.forOwn(scope.contentType[currentContentType], function (v, k) {
                    if ((state === false && k === "false") || k === state){ // false boolean value   is linked to   "false" entry in states
                        ob = v;
                        return;
                    }
                });
                return ob;
            };

            // When we are getting status of inter on the task page, we need to specifically load them as they are
            // not saved int the contentType
            scope.getStateInterByValue = function (state) {
                var ob;
                var contentType = swif.settings.getContentType('intervention');
                _.forOwn(contentType.states, function (v, k) {
                    if ((state === false && k === "false") || k === state){ // false boolean value   is linked to   "false" entry in states
                        ob = v;
                        return;
                    }
                });
                return ob;
            };

            scope.getFilterValueById = function (field, id) {
                var value;
                _.forEach(scope.vocabulary[field], function (v) {
                    if (v.id === id) {
                        value = v;
                    }
                });
                if (!value) {} // supported by loadVocabularies
                return value;
            };
            scope.toggleDateRelative = function (filter) {
                filter.is_relative = !filter.is_relative;
            };
            var initialize = function (){
                //scope.query = vv.query;
                scope.filters = swif.data.getFilters(scope.collection.currentFilter);
                scope.extraFilters = swif.data.getExtraFilters(scope.collection.currentFilter);
                scope.contentType = swif.settings.getContentType(scope.collection.contentType);

                // if 'is_set' or 'is_not_set' filter is used, we re-format it to be used by the template
                formatIsSetFilters(scope.filters);

                if (scope.contentType !== undefined) {
                    scope.settings = scope.contentType.filterSettings;

                    swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
                        if(company.processing_times_enable) {
                            // Display specific filters
                            scope.processingTimesEnable = company.processing_times_enable;
                        } else {
                            // if the 'processing times' feature is disable, remove the concerned filters from filters
                            scope.settings = _.filter(scope.contentType.filterSettings, function (filter) {
                                return !['response_time_status', 'total_process_time_status'].includes(filter.field)
                            });
                        }
                        _.forEach(scope.settings, function (value) {
                            value.complete_name = swif.i18n.getString(value.name);
                        });
                        if (scope.contentType.has_custom_fields && swif.settings.app.features.patrimonyCustomFields) {
                            swif.data.callKw(
                                scope.contentType.id,
                                'get_custom_attributes'
                            ).then(function (data) {
                                scope.settings = scope.settings.concat(data);
                                loadVocabularies();
                            });
                        }
                    });


                    scope.stateFilters = [];
                    scope.firstResponseTimeStates = [];
                    scope.responseTimeStates = [];
                    scope.processingTimeStates = [];

                    // Generate states buttons
                    [
                        { stateName: 'states', scopeName: 'stateFilters' },
                        { stateName: 'first_response_time_states', scopeName: 'firstResponseTimeStates' },
                        { stateName: 'response_time_states', scopeName: 'responseTimeStates' },
                        { stateName: 'total_process_time_states', scopeName: 'processingTimeStates' }
                    ].forEach(function(state) {
                        _.forOwn(scope.contentType[state.stateName], function (v, k) {
                            v.id = k;
                            scope[state.scopeName].push(v);
                        });
                    });

                    scope.stateFilters = _.sortByAll(scope.stateFilters, 'index');
                }
                scope.newfilter = {};
                loadOperator();
                loadVocabularies();
                loadMyFilters();
                loadTextFilters();
            };

            var setSortOn = function() {
                var sort = swif.data.getSort(scope.collection.currentFilter);
                // set a default value to sort if no one is found from collection
                sort = !_.isEmpty(sort) ? sort : {order: scope.sortOrders[0].id};
                if (sort.order) {
                    _.forEach(scope.sortOrders, function (c) {
                        sort.order = sort.order.replace(',', ''); // Remove trailing comma in case of multiple orders
                        if (c.id === sort.order) {
                            scope.sortOrder = c;
                        }
                    });
                }
                if (sort.key && scope.contentType.sortOn) {
                    _.forEach(scope.contentType.sortOn, function (s) {
                        if (s.id === sort.key) {
                            scope.sortOn.value = s;
                        }
                    });
                } else {
                    scope.sortOn.value = scope.sortOnFields[0];
                }
            };

            ngModel.$render = function () {
                scope.collection = ngModel.$viewValue;
                if (scope.collection !== undefined) {
                    scope.hasFilterModel = (scope.collection.currentFilter !== undefined);
                    scope.limitPerPage.limit = scope.collection.currentFilter.limit;
                    initialize();
                    scope.sortOn = {};
                    setSortOn();
                }
            };
            scope.resetCartItemsFilter = function () {
                swif.data.resetExtraFilter(scope.collection.currentFilter, 'cartItems');
            };
            scope.resetCartItemsFilter = function () {
                swif.data.resetExtraFilter(scope.collection.currentFilter, 'cartItems');
            };
            scope.setCurrentCartFilter = function () {
                var ids = swif.cart.getCartItemsIds(scope.collection.contentType);
                var filter = {};
                swif.data.addExtraFilter(filter, 'cartItems', 'id', 'in', ids);
                scope.collection.currentFilter = filter;
                scope.displayFilters = false;
            };
            scope.doSearch = function ($select, filterTarget) {
                var filterSettings = getFilterSettings(filterTarget);

                if (filterSettings.choices) {
                    var filter = angular.copy(filterSettings.choices);

                    filter.fields = ['id', 'name', 'complete_name'];
                    swif.data.setLimit(filter, 300);

                    if ($select.search) {
                        swif.data.addFilter(filter, 'name', 'ilike', $select.search);
                    }
                    // Set filter collection sort order
                    var contentType = swif.settings.getContentType(filterSettings.content_type);

                    if (contentType.filterSort) {
                        swif.data.sortOnRaw(filter, contentType.filterSort);
                    }

                    scope.loading[filterTarget.field] = {};

                    swif.message.loading(scope.loading[filterTarget.field]);
                    swif.data.get(filterSettings.content_type, undefined, filter)
                    .then(function (data) {
                        // Store results for ui-select display
                        scope.vocabularyDisplay[filterTarget.field] = data;

                        // Merge existing results with new ones
                        // Dedupe on id because a search could return already
                        // existing results
                        scope.vocabulary[filterTarget.field] = _.uniq(
                            scope.vocabulary[filterTarget.field].concat(data), 'id');
                        swif.message.loading(scope.loading[filterTarget.field], 'ok');
                    }, onError);
                }
            };
            scope.$watch('collection.currentFilter', function (newV, oldV) {
                if (!_.isEqual(newV, oldV)) {
                    scope.filters = swif.data.getFilters(scope.collection.currentFilter);
                    scope.extraFilters = swif.data.getExtraFilters(scope.collection.currentFilter);

                    // if 'is_set' or 'is_not_set' filter is used, we re-format it to be used by the template
                    formatIsSetFilters(scope.filters);
                }
            }, true);
            scope.$watch('collection.contentType', function (newV, oldV) {
                if (newV && newV !== oldV) {
                    ngModel.$render();
                }
            });
            scope.$watch('collection.currentCount', function (newV, oldV) {
                if (newV && newV !== oldV) {
                    if (scope.totalCount) {
                        scope.totalCount({$value: newV});
                    }
                }
            });
            scope.$watch('newfilter.selected', function (newV) {
                // Fix zIndex bug with ui-select-multiple
                var list = document.getElementsByClassName('ui-select-multiple');
                var zIndex = 1000; // start value
                for (var i = 0; i < list.length; i++) {
                    list[i].style.zIndex = zIndex;
                    zIndex--;
                }
                if (newV !== undefined) {
                    if (newV.field !== undefined) {
                        var field = newV.field;
                        var operator;
                        if (_.isArray(scope.operators[field])) {
                            if (scope.operators[field].length > 0) {
                                operator = scope.operators[field][0].value;
                            }
                        }
                        if (newV.type === 'bool') {
                            newV.value = false;
                        }
                        scope.filters.push({
                            field: field,
                            operator: operator,
                            value: newV.value
                        });
                    }
                }
                scope.newfilter = {}; //reset
            });
            scope.$watch('text.value', function (newV, oldV) {
                if (!_.isEmpty(oldV) && _.isEmpty(newV)) {
                    scope.updateModel();
                }
            });
        }
    }

    function swifOpenFilterInModal($uibModal, swif) {
        'ngInject';
        return {
            restrict: 'A',
//            require: 'ngModel',
            scope: {
                swifOpenFilterInModal: '=',
                options: '='
            },
            link: function (scope, element) {
                var onclick = function () {
                    var params = angular.copy(scope.options.modal);
                    scope.modalParams = params;
                    var filter = angular.copy(scope.swifOpenFilterInModal);
                    params.scope = scope;
                    params.size = params.size || 'lg';
                    params.templateUrl = scope.options.modal.templateUrl;
                    swif.collections.createOrUpdate(
                        'swif-open-filter-in-modal',
                        scope.options.contentType, filter, {limitPerPage: 10}
                    ).then(function (collection) {
                        params.collection = collection;
                        scope.modalInstance = $uibModal.open(params);
                    });
                };
                element.bind('click', onclick);
                scope.$on('$destroy', function () {
                    element.unbind('click', onclick);
                });
                scope.openInModule = function () {
                    scope.closeModal();
                    var collection = scope.modalParams.collection;
                    var alert = angular.copy(collection.currentFilter);
                    alert.model_id = swif.settings.getContentType(collection.contentType).model;
                    if (!alert.ui_context) {
                        alert.ui_context = {};
                    }
                    alert.ui_context.contentType = collection.contentType;
                    swif.alerter.applyAlertFilter(alert);
                };
                scope.closeModal = function () {
                    scope.modalInstance.close();
                };
            }
        };
    }


})();
